import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'price',
})
export class PricePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const decimals = args[0];
    const locale = args[1];

    value = value ? (typeof value !== 'number' ? +value.replace(/[^0-9.]/g, '') : value) : 0;

    return this.formatMoney(+value, decimals, locale);
  }

  formatMoney(value: number, decimals: boolean = true, locale = 'en') {
    // Determine the symbol
    let symbol: string;
    switch (locale) {
      case 'es':
        symbol = '₱';
        break;
      case 'fr':
        symbol = '₣';
        break;
      case 'pt-br':
        symbol = '€';
        break;
      default:
        symbol = '$';
    }

    // Remove the decimals if specified
    if (!decimals) {
      value = Math.round(value);
    }

    let negation: string = '';
    if (value < 0) {
      negation = '-';
      value = Math.abs(value);
    }

    // Add commas to the price
    const total = value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    // Join and trim trailing zeros
    if (!decimals || value.toString().search(/\./g) === -1) {
      return `${negation}${symbol}${total}`.replace(/\.00$/, '');
    } else {
      return `${negation}${symbol}${total}`;
    }
  }
}
